<wilson-page-frame-v2>
  <ng-container headerContent>
    <div class="d-flex gap-2">
      <wilson-search-filter
        [debounceTime]="200"
        (modelChange)="onSearchChange($event)"
      ></wilson-search-filter>
      <nz-badge [nzCount]="(numberOfAppliedFilters$ | async) ?? undefined">
        <button nz-button nzType="default" (click)="openDrawer()">
          <fa-icon [icon]="faFilter"></fa-icon>
        </button>
      </nz-badge>
    </div>
    <div class="d-flex gap-2">
      <wilson-training-qualification-delete-trigger
        (refresh)="refreshSubject.next($event)"
      ></wilson-training-qualification-delete-trigger>
      <wilson-training-qualification-create-trigger></wilson-training-qualification-create-trigger>
      <wilson-training-qualification-bulk-edit-trigger
        (refresh)="refreshSubject.next($event)"
      ></wilson-training-qualification-bulk-edit-trigger>
      <wilson-training-qualification-finalize-trigger
        (refresh)="refreshSubject.next($event)"
      ></wilson-training-qualification-finalize-trigger>
    </div>
  </ng-container>
  <ng-container mainContent>
    <wilson-qualification-trainings-v2-list
      [searchFilter]="searchFilter"
      [statusFilter]="statusFilter"
      [usersFilter]="usersFilter"
      [qualificationFilter]="qualificationFilter"
      [refreshSubject]="refreshSubject"
      (selectedRowsChange)="onSelectedRowsChange($event)"
    ></wilson-qualification-trainings-v2-list>
  </ng-container>
</wilson-page-frame-v2>

<wilson-training-qualifications-filter-drawer
  [isDrawerVisible]="isDrawerVisible"
  (closeDrawer)="isDrawerVisible = false"
  (applyFilters)="onApplyFilters($event)"
></wilson-training-qualifications-filter-drawer>

<wilson-training-qualification-create-drawer></wilson-training-qualification-create-drawer>

<wilson-training-qualifications-bulk-edit-drawer></wilson-training-qualifications-bulk-edit-drawer>

<wilson-training-qualifications-finalize-drawer></wilson-training-qualifications-finalize-drawer>
